// src/components/layout/Header.jsx
import React, { useState } from 'react';
import { FiMenu, FiBell, FiLogOut, FiSun, FiMoon, FiSidebar, FiX } from 'react-icons/fi';
import ConfirmModal from '../components/ConfirmModal';
import Breadcrumb from './Breadcrumb';

const Header = ({ 
  onToggleSidebar, 
  onToggleSidebarVisibility, // New prop
  sidebarVisible, // New prop
  user, 
  onLogout 
}) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const handleLogout = () => {
    onLogout();
    setShowLogoutModal(false);
  };

  return (
    <>
      <header className="bg-white dark:bg-gray-800 shadow-sm z-10 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between p-4">
          <div className="flex items-center">
            {/* Mobile menu toggle */}
            <button
              onClick={onToggleSidebar}
              className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 lg:hidden"
            >
              <FiMenu className="w-5 h-5" />
            </button>
            
            {/* Sidebar visibility toggle - only on desktop */}
            <button
              onClick={onToggleSidebarVisibility}
              className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 hidden lg:flex"
            >
              {sidebarVisible ? <FiX className="w-5 h-5" /> : <FiSidebar className="w-5 h-5" />}
            </button>
            
            <div className="ml-4">
              <h1 className="text-xl font-semibold text-gray-800 dark:text-white">
                MBB Dashboard
              </h1>
              <Breadcrumb />
            </div>
          </div>

          <div className="flex items-center space-x-4">
          

            {/* User info */}
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white shadow-sm">
                <span className="text-sm font-medium">
                  {user?.email?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
              <div className="hidden md:block">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  {user?.email?.split('@')[0]}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 capitalize">
                  {user?.role}
                </p>
              </div>
            </div>

            {/* Logout button */}
            <button
              onClick={() => setShowLogoutModal(true)}
              className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
              title="Logout"
            >
              <FiLogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </header>

      <ConfirmModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
        title="Confirm Logout"
        message="Are you sure you want to logout?"
        confirmText="Logout"
        type="danger"
      />
    </>
  );
};

export default Header;